<app-modal-dialog
  [show]="showModal"
  size="lg"
  position="top"
  (closed)="closeModal(null)"
  #modal
>
  <div class="modal-header" modal-header>
    <h1>Factura de Venta</h1>
    <h1 style="left: 0" class="i-hover">
      <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
    </h1>
  </div>

  <div class="modal-body" modal-body *ngIf="invoiceData">
    <!-- Información general -->
    <div class="row mb-3">
      <div class="col-md-4">
        <label class="fw-bold">Serie</label>
        <div>{{ invoiceData.clientInvoice.series }}</div>
      </div>
      <div class="col-md-4">
        <label class="fw-bold">Número</label>
        <div>{{ invoiceData.clientInvoice.number }}</div>
      </div>
      <div class="col-md-4">
        <label class="fw-bold">Fecha</label>
        <div>{{ formatDate(invoiceData.clientInvoice.date) }}</div>
      </div>
    </div>

    <!-- Cliente -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="fw-bold">Cliente</label>
        <div>{{ invoiceData.clientInvoice.name }}</div>
      </div>
      <div class="col-md-3">
        <label class="fw-bold">NIT</label>
        <div>{{ invoiceData.clientInvoice.nit }}</div>
      </div>
      <div class="col-md-3">
        <label class="fw-bold">Código</label>
        <div>{{ invoiceData.clientInvoice.clientData?.code }}</div>
      </div>
    </div>

    <!-- Bodega -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="fw-bold">Bodega</label>
        <div>{{ invoiceData.clientInvoice.warehouseData?.name }}</div>
      </div>
      <div class="col-md-6">
        <label class="fw-bold">Dirección</label>
        <div>{{ invoiceData.clientInvoice.warehouseData?.address }}</div>
      </div>
    </div>

    <!-- Descripción -->
    <div class="row mb-3">
      <div class="col">
        <label class="fw-bold">Descripción</label>
        <div>{{ invoiceData.clientInvoice.description || '—' }}</div>
      </div>
    </div>

    <!-- Tabla de detalles -->
    <div class="table-responsive table-bordered">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Código</th>
            <th>Producto</th>
            <th class="text-end">Cantidad</th>
            <th class="text-end">Precio (Q)</th>
            <th class="text-end">Subtotal (Q)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of invoiceData.details">
            <td>{{ d.productData?.code }}</td>
            <td>{{ d.descriptionProduct }}</td>
            <td class="text-end">{{ d.quantity | number:'1.0-2' }}</td>
            <td class="text-end">{{ d.price | number:'1.2-2' }}</td>
            <td class="text-end">{{ (d.price * d.quantity) | number:'1.2-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Total -->
    <div class="row mt-3">
      <div class="col text-end">
        <h4 class="fw-bold">Total: Q{{ getTotal() | number:'1.2-2' }}</h4>
      </div>
    </div>
  </div>

  <div class="modal-footer" modal-footer>
    <button class="btn btn-secondary" (click)="closeModal(modal)">
      <i class="fa fa-times"></i> Cerrar
    </button>
  </div>
</app-modal-dialog>
